var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabbarPage"},[_c('div',{staticClass:"my_tabbar flex-between"},_vm._l((_vm.tabList),function(item,index){return _c('div',{key:index + 'a',staticClass:"my_tabba_item",class:{ active: _vm.tabbarActive == index },on:{"click":function($event){return _vm.handleNavBar(index)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }